import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ms_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  if (cfg.method === "get") cfg.params = { ...(cfg.params || {}), lang: localStorage.getItem("ms_lang") || "en" };
  return cfg;
});

export const useApi = (key, path, opts = {}) =>
  useQuery({ queryKey: [key, path, localStorage.getItem("ms_lang") || "en"], queryFn: async () => (await http.get(path)).data, enabled: !!path, ...opts });

export function errorText(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail?.msg || String(detail);
}
